<template>
  <div class="page_wrapper">
    <div class="result_box">
      <!-- 左侧：得分概览 -->
      <div class="left">
        <div class="section_card score_card">
          <div class="score_label">成绩概览</div>
          <div class="press_box">
            <el-progress type="dashboard" :percentage="percentage" color="#646eff" :stroke-width="12" :show-text="false"
              define-back-color="#eef0ff"></el-progress>
            <div class="info_box">
              <div class="point">{{ pageInfo.score }}<span class="point_unit">分</span></div>
              <div class="text">得分</div>
            </div>
          </div>
          <div class="exam_info_box">
            <div class="exam_info_item">
              <div class="text1">{{ pageInfo.ques_all }}</div>
              <div class="text2">一共</div>
            </div>
            <div class="info_sep"></div>
            <div class="exam_info_item">
              <div class="text1">{{ pageInfo.already_answer }}</div>
              <div class="text2">已答题</div>
            </div>
            <div class="info_sep"></div>
            <div class="exam_info_item">
              <div class="text1">{{ pageInfo.not_answer }}</div>
              <div class="text2">未答题</div>
            </div>
            <div class="info_sep"></div>
            <div class="exam_info_item">
              <div class="text1">{{ pageInfo.take_time }}</div>
              <div class="text2">用时</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分隔线 -->
      <div class="divider_line"></div>

      <!-- 右侧：得分详情 -->
      <div class="right">
        <div class="section_card detail_card">
          <div class="section_title">
            <span class="title_icon"></span>
            得分情况
          </div>
          <div class="point_box">
            <div class="point_item header_item">
              <div>题型</div>
              <div>总数</div>
              <div>正确题数</div>
              <div>正确率</div>
            </div>
            <div class="point_item" v-for="(item, index) in pageInfo.ques_type" :key="index">
              <div class="type_name">{{ item.title }}</div>
              <div class="type_count">{{ item.ques_count }}</div>
              <div class="type_correct">{{ item.ques_type == 6 && !isMoKao?'待阅卷':item.ques_type == 6 && isMoKao?'-':item.correct_count }}</div>
              <div class="type_accuracy">
                <span v-if="item.ques_type == 6 && !isMoKao" class="badge badge_pending">待阅卷</span>
                <span v-else-if="item.ques_type == 6 && isMoKao" class="badge badge_dash">-</span>
                <span v-else class="accuracy_badge" :class="{'accuracy_high': parseInt(item.accuracy) >= 80, 'accuracy_mid': parseInt(item.accuracy) >= 60 && parseInt(item.accuracy) < 80, 'accuracy_low': parseInt(item.accuracy) < 60}">{{ item.accuracy }}%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_area">
          <div class="btn_group">
            <div v-if="isMoKao || isZhuanKao" class="btn btn_secondary" @click="lookWrong" v-throttle>
              <span class="btn_icon icon_wrong"></span>查看错题
            </div>
            <div v-if="isMoKao || isZhuanKao" class="btn btn_secondary" @click="lookAll" v-throttle>
              <span class="btn_icon icon_all"></span>查看全卷
            </div>
            <div class="btn btn_primary" @click="pageBack" v-throttle>
              <span class="btn_icon icon_back"></span>返回
            </div>
          </div>
          <div class="btn_hint">点击返回可退出本次考试结果</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _examResult } from "../api/resultPage"
import * as global from '@/mixins/global.js';
export default {
  components: {},
  created() {
    this.examResult()
  },

  mounted() { },
  data() {
    return {
      percentage: 0,
      pageInfo: {}
    };
  },
  computed: {
  	isMoKao() {
  		return this.$route.query.examType == global.ExamType.MoKao;
  	},
    isZhuanKao() {
      return this.$route.query.examType == global.ExamType.ZhuanKao;
    },
  },
  methods: {
    async examResult() {
      let params = {
        exam_id: window.localStorage.getItem("exam_id")
      }
      let res = await _examResult(params)
      this.pageInfo = res.data

      this.percentage =   this.GetPercent( this.pageInfo.already_answer, this.pageInfo.ques_all)
    },
    pageBack() {
      if (this.isZhuanKao) {
        this.$router.replace({ path: "/Index/ExamTab"});
      } else {
        this.$router.replace({ path: "/Index/TYKSList", query:{
          ...this.$route.query
        } });
      }
    },
    GetPercent(num, total) {
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
        return "-";
      }
      return total <= 0 ? "0%" : (Math.round(num / total * 10000) / 100.00) ;
    },
    lookWrong() {
    	const exam_id = window.localStorage.getItem("exam_id");
    	window.localStorage.setItem("lookObjectExamID", exam_id);
    	this.$router.push({
    		name: 'LookWrong'
    	});
    },
    lookAll() {
    	const exam_id = window.localStorage.getItem("exam_id");
    	window.localStorage.setItem("lookObjectExamID", exam_id);
    	this.$router.push({
    		name: 'LookAll'
    	});
    }
  },


};
</script>
<style scoped>
.page_wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(ellipse at 20% 50%, rgba(100, 110, 255, 0.04) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 20%, rgba(54, 194, 117, 0.02) 0%, transparent 50%),
    radial-gradient(ellipse at 50% 90%, rgba(245, 166, 35, 0.02) 0%, transparent 40%);
}

.result_box {
  width: 1100px;
  min-height: 520px;
  display: flex;
  align-items: stretch;
  background: linear-gradient(145deg, #f2f4fc 0%, #f7f8fd 100%);
  border-radius: 16px;
  box-shadow:
    0 4px 24px rgba(100, 110, 255, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(100, 110, 255, 0.06);
  padding: 20px;
  box-sizing: border-box;
  animation: fadeUp 0.5s ease-out;
  position: relative;
}

.result_box::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 28px;
  right: 28px;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(100, 110, 255, 0.06), rgba(54, 194, 117, 0.04), rgba(245, 166, 35, 0.06), transparent);
  border-radius: 1px;
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 左侧 */
.left {
  width: 420px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.left .section_card {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* 分隔线 */
.divider_line {
  width: 1px;
  align-self: stretch;
  margin: 10px 20px;
  background: linear-gradient(180deg, transparent 0%, rgba(100, 110, 255, 0.1) 30%, rgba(100, 110, 255, 0.1) 70%, transparent 100%);
  flex-shrink: 0;
}

/* 右侧 */
.right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0;
}

/* 通用卡片 */
.section_card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.04);
  overflow: hidden;
  transition: box-shadow 0.3s ease, transform 0.3s ease, border-color 0.3s ease;
}

.section_card:hover {
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: rgba(100, 110, 255, 0.08);
}

/* 卡片顶部色带 */
.section_card::before {
  content: '';
  display: block;
  height: 4px;
  background: linear-gradient(90deg, #646eff, #8b8eff);
}

.score_card {
  animation: cardIn 0.45s ease-out 0.1s both;
}

.detail_card {
  animation: cardIn 0.45s ease-out 0.2s both;
  flex: 1;
}

.btn_area {
  animation: cardIn 0.45s ease-out 0.35s both;
}

@keyframes cardIn {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 得分区域 */
.score_card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 24px 24px;
}

.score_card .press_box {
  flex-shrink: 0;
}

.score_card .exam_info_box {
  margin-top: auto;
}

.score_label {
  font-size: 13px;
  color: #9099a4;
  letter-spacing: 2px;
  margin-bottom: 16px;
  text-transform: uppercase;
  font-weight: 500;
}

.press_box {
  width: 170px;
  height: 170px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f8f9ff, #eef0ff);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(100, 110, 255, 0.12);
  animation: scoreGlow 3s ease-in-out infinite;
}

@keyframes scoreGlow {
  0%, 100% { box-shadow: 0 4px 20px rgba(100, 110, 255, 0.12); }
  50% { box-shadow: 0 4px 30px rgba(100, 110, 255, 0.2), 0 0 40px rgba(100, 110, 255, 0.06); }
}

.info_box {
  width: 50%;
  height: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 14px;
}

.info_box .point {
  color: #646eff;
  font-weight: 700;
  font-size: 32px;
  white-space: nowrap;
  line-height: 1;
}

.info_box .point_unit {
  font-size: 16px;
  font-weight: 600;
  margin-left: 2px;
}

.info_box .text {
  color: #9099a4;
  font-size: 13px;
  margin-top: 6px;
  letter-spacing: 1px;
}

.exam_info_box {
  width: 100%;
  border-radius: 10px;
  background: linear-gradient(135deg, #f8f9ff, #f2f4fc);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 16px 12px;
  border: 1px solid rgba(100, 110, 255, 0.06);
}

.exam_info_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  transition: transform 0.25s ease;
}

.exam_info_item:hover {
  transform: translateY(-2px);
}

.exam_info_item .text1 {
  color: #1d2536;
  font-size: 22px;
  font-weight: 700;
  font-family: 'Consolas', 'Monaco', monospace;
}

.exam_info_item .text2 {
  color: #9099a4;
  font-size: 11px;
  margin-top: 6px;
  letter-spacing: 0.5px;
}

.info_sep {
  width: 1px;
  height: 28px;
  background: linear-gradient(180deg, transparent, rgba(100, 110, 255, 0.12), transparent);
  flex-shrink: 0;
}

/* 区块标题 */
.section_title {
  display: flex;
  align-items: center;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
  color: #1d2536;
  border-bottom: 1px solid #f0f2f5;
  background:
    linear-gradient(90deg, rgba(100, 110, 255, 0.02), transparent 60%),
    #fafbfd;
  border-left: 3px solid #646eff;
}

.title_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  margin-right: 10px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #646eff, #8b8eff);
  position: relative;
}

.title_icon::after {
  content: '';
  width: 10px;
  height: 8px;
  border: 2px solid rgba(255,255,255,0.85);
  border-radius: 1px;
  margin-top: -1px;
}

/* 得分表格 */
.point_box {
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 12px 24px 16px;
}

.point_item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-radius: 6px;
  border-bottom: 1px dashed #f0f2f5;
  transition: all 0.25s ease;
}

.point_item:hover {
  background-color: #f5f6fc;
  padding-left: 16px;
  border-bottom-color: transparent;
  border-left: 2px solid rgba(100, 110, 255, 0.15);
}

.point_item:last-child {
  border-bottom: none;
}

.point_item div {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a4e5a;
  font-size: 14px;
}

.header_item {
  background: linear-gradient(90deg, rgba(100, 110, 255, 0.03), transparent);
  border-radius: 8px;
  margin-bottom: 4px;
  border-bottom: 1px solid #eef0ff !important;
  padding: 12px !important;
}

.header_item div {
  color: #646eff !important;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* 数据行交错入场 */
.point_item:nth-child(2) { animation: cardIn 0.35s ease-out 0.3s both; }
.point_item:nth-child(3) { animation: cardIn 0.35s ease-out 0.38s both; }
.point_item:nth-child(4) { animation: cardIn 0.35s ease-out 0.46s both; }
.point_item:nth-child(5) { animation: cardIn 0.35s ease-out 0.54s both; }
.point_item:nth-child(6) { animation: cardIn 0.35s ease-out 0.62s both; }

.type_name {
  font-weight: 500;
  color: #1d2536 !important;
}

.type_count {
  font-family: 'Consolas', 'Monaco', monospace;
}

.type_correct {
  font-family: 'Consolas', 'Monaco', monospace;
}

.accuracy_badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Consolas', 'Monaco', monospace;
  transition: transform 0.2s ease;
}

.point_item:hover .accuracy_badge {
  transform: scale(1.05);
}

.accuracy_high {
  background: rgba(54, 194, 117, 0.1);
  color: #36c275;
  border: 1px solid rgba(54, 194, 117, 0.2);
}

.accuracy_mid {
  background: rgba(245, 166, 35, 0.1);
  color: #f5a623;
  border: 1px solid rgba(245, 166, 35, 0.2);
}

.accuracy_low {
  background: rgba(235, 64, 52, 0.08);
  color: #eb4034;
  border: 1px solid rgba(235, 64, 52, 0.15);
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.badge_pending {
  background: rgba(245, 166, 35, 0.1);
  color: #f5a623;
  border: 1px solid rgba(245, 166, 35, 0.2);
  animation: pendingPulse 2s ease-in-out infinite;
}

@keyframes pendingPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.badge_dash {
  color: #c5c9d6;
  font-size: 14px;
}

/* 按钮区域 */
.btn_area {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.04);
  padding: 20px 24px 16px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.btn_area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #646eff, #8b8eff);
}

.btn_group {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.btn {
  padding: 12px 32px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn_icon {
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}

.icon_wrong::after {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 2px solid currentColor;
}

.icon_all::after {
  content: '';
  width: 9px;
  height: 7px;
  border: 2px solid currentColor;
  border-radius: 1px;
}

.icon_back::after {
  content: '';
  width: 0;
  height: 0;
  border-right: 5px solid currentColor;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  margin-right: 3px;
}

.btn_primary {
  background: linear-gradient(135deg, #646eff, #7b84ff);
  color: #fff;
  box-shadow: 0 4px 14px rgba(100, 110, 255, 0.35);
  position: relative;
  overflow: hidden;
}

.btn_primary::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent);
  transition: left 0.5s ease;
}

.btn_primary:hover::after {
  left: 100%;
}

.btn_primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(100, 110, 255, 0.45);
  background: linear-gradient(135deg, #5a64f0, #7078f0);
}

.btn_primary:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(100, 110, 255, 0.3);
}

.btn_secondary {
  background: #fff;
  color: #646eff;
  border: 1px solid rgba(100, 110, 255, 0.25);
  box-shadow: 0 2px 8px rgba(100, 110, 255, 0.08);
}

.btn_secondary:hover {
  background: linear-gradient(135deg, rgba(100, 110, 255, 0.04), rgba(100, 110, 255, 0.08));
  border-color: rgba(100, 110, 255, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(100, 110, 255, 0.15);
}

.btn_secondary:active {
  transform: translateY(0);
}

.btn_hint {
  font-size: 12px;
  color: #b0b5c4;
  text-align: center;
  letter-spacing: 0.5px;
  margin-top: -4px;
}
</style>
